import { SliderScroll } from '../_app/cuchillo/components/SliderScroll';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { gsap } from "gsap";
import Scroll_Item from '../_app/cuchillo/scroll/Scroll_Item';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Maths } from '../_app/cuchillo/utils/Maths';
import { Metrics } from '../_app/cuchillo/core/Metrics';

class ScrollItem__SliderImages extends Scroll_Item {
  _call;
  _slider;
  _sizes = {
    scale_left: 0,
    x_left: 0,
    scale_center: 0,
    x_center: 0,
    scale_right: 0,
    x_right: 0
  }

  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================
  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);

    this._slider = new SliderScroll(__link, {
      interaction: true,
      hasScrollbar: false,
      itemClass: ScrollItem__SliderImages__Item
    });

    this._call = () => this.loop();
    this.onShow = () => {
      gsap.ticker.add(this._call);
    };

    this.onHide = () => {
      gsap.ticker.remove(this._call);
    };
  }

  resize(w, h) {
    super.resize(w, h);

    const rectLeft = GetBy.class("__targetLeft", this.item)[0].getBoundingClientRect();
    const rectCenter = GetBy.class("__targetCenter", this.item)[0].getBoundingClientRect();
    const rectRight = GetBy.class("__targetRight", this.item)[0].getBoundingClientRect();

    // Escala base (center)
    const centerWidth = rectCenter.width;

    this._sizes = {
      scale_left: rectLeft.width / centerWidth,
      x_left: rectLeft.left,
      scale_center: 1,
      x_center: rectCenter.left,
      scale_right: rectRight.width / centerWidth,
      x_right: rectRight.left
    };

    if (this._slider) this._slider.resize(this._sizes);
  }

  loop() {
    if (this._slider) {
      this._slider.loop();
    }
  }

  dispose() {
    if (this._slider) this._slider.dispose();
    super.dispose();
  }
}

class ScrollItem__SliderImages__Item extends VScroll_Item {
  hasHiddenEnabled = false;
  _figure;
  _image;

  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================

  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);

    this._figure = GetBy.id(this.item.dataset.id);
    this._image = GetBy.selector("img", this._figure)[0];

    this.onShow = () => { };

    this.onHide = () => { };
  }

  drawHook() {
    if (!this._sizes) return;

    let scale_figure, x_figure;
    const p = this.progress;

    if (p <= 0) {
      // right_right → right
      const t = (p + 0.5) / 0.5; // Normaliza de -0.5→0 a 0→1
      scale_figure = Maths.lerp(this._sizes.scale_right_right, this._sizes.scale_right, t);
      x_figure = Maths.lerp(this._sizes.x_right_right, this._sizes.x_right, t);
    } else if (p <= 0.5) {
      // right → center
      const t = p / 0.5; // 0→0.5 a 0→1
      scale_figure = Maths.lerp(this._sizes.scale_right, this._sizes.scale_center, t);
      x_figure = Maths.lerp(this._sizes.x_right, this._sizes.x_center, t);
    } else if (p <= 1.0) {
      // center → left
      const t = (p - 0.5) / 0.5; // 0.5→1.0 a 0→1
      scale_figure = Maths.lerp(this._sizes.scale_center, this._sizes.scale_left, t);
      x_figure = Maths.lerp(this._sizes.x_center, this._sizes.x_left, t);
    } else {
      // left → left_left
      const t = (p - 1.0) / 0.5; // 1.0→1.5 a 0→1
      scale_figure = Maths.lerp(this._sizes.scale_left, this._sizes.scale_left_left, t);
      x_figure = Maths.lerp(this._sizes.x_left, this._sizes.x_left_left, t);
    }

    this._figure.style.transform = `translateX(${x_figure}px)`;
    this._image.style.transform = `scale(${scale_figure})`;
  }


  resize(w, h) {
    super.resize(w, h);

    const rectScaleLeftLeft = GetBy.class("__targetLeftLeft")[0].parentNode.getBoundingClientRect();
    const rectScaleLeft = GetBy.class("__targetLeft")[0].parentNode.getBoundingClientRect();
    const rectScaleCenter = GetBy.class("__targetCenter")[0].parentNode.getBoundingClientRect();
    const rectScaleRight = GetBy.class("__targetRight")[0].parentNode.getBoundingClientRect();
    const rectScaleRightRight = GetBy.class("__targetRightRight")[0].parentNode.getBoundingClientRect();

    const rectLeftLeft = GetBy.class("__targetLeftLeft")[0].getBoundingClientRect();
    const rectLeft = GetBy.class("__targetLeft")[0].getBoundingClientRect();
    const rectCenter = GetBy.class("__targetCenter")[0].getBoundingClientRect();
    const rectRight = GetBy.class("__targetRight")[0].getBoundingClientRect();
    const rectRightRight = GetBy.class("__targetRightRight")[0].getBoundingClientRect();

    this._sizes = {
      scale_left_left: rectScaleLeft.width / rectScaleCenter.width,
      x_left_left: rectLeftLeft.left,

      scale_left: rectScaleLeft.width / rectScaleCenter.width,
      x_left: rectLeft.left,

      scale_center: 1,
      x_center: rectCenter.left,

      scale_right: rectScaleRight.width / rectScaleCenter.width,
      x_right: rectRight.left,

      scale_right_right: rectScaleRight.width / rectScaleCenter.width,
      x_right_right: rectRightRight.left,
    };
  }
}

Scroll._registerClass('slider-images', ScrollItem__SliderImages);
